import { ReactNode } from 'react';

import { NavigationContext } from 'components/navigation/navigation_wrapper/context';
import { useSuperState } from 'hooks';
import { useApp } from 'app/context';

/** A single navigation menu item returned by the server. */
export type NavigationItem = {
    id: string; // Unique identifier matching the server-side menu item ID.
    children: NavigationItem[]; // Child menu items (expandable section).
    icon: string; // CSS class for a Font Awesome icon (e.g. "fa-solid fa-house")
    iconLink: string; // Path to a custom SVG icon (used instead of `icon` when provided).
    label: string; // Display label for the menu item.
    linkTarget: string; // Link target behavior.
    path: string; // URL path this item navigates to.
};

export type NavigationContextValue = {
    allowedItems: string[];
    pendingOrderCount: number;
};

export type NavigationWrapperProps = {
    children: ReactNode;
};

export const NavigationWrapper = (props: NavigationWrapperProps) => {

    const { children } = props;

    const app = useApp();

    const [state] = useSuperState({
        allowedItems: app.allowedItems ?? [] as string[],
        pendingOrderCount: app.pendingOrderCount ?? 0
    });
    const { allowedItems, pendingOrderCount } = state;

    const context: NavigationContextValue = {
        allowedItems,
        pendingOrderCount
    };

    return (
        <NavigationContext.Provider value={context}>
            {children}
        </NavigationContext.Provider>
    );

};
